document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.klaviyo-wrapper');

  wrappers.forEach(function (wrapper) {
    var submitButton = wrapper.querySelector('.button-submit-klaviyo');
    if (!submitButton) return;

    submitButton.addEventListener('click', async function (event) {
      event.preventDefault();

      var form = wrapper.querySelector('form');
      if (form) {
        form.classList.add('active-loader');
      }

      var emailInput = wrapper.querySelector('.email-capture__input');
      var email = emailInput ? emailInput.value : '';
      var listId = wrapper.getAttribute('data-listid');
      var ip = null;

      try {
        var ipResponse = await fetch('https://jsonip.com/');
        if (ipResponse.ok) {
          var ipData = await ipResponse.json();
          ip = ipData && ipData.ip ? ipData.ip : null;
        }
      } catch (error) {
        // Keep request flow even when IP lookup fails.
        ip = null;
      }

      var options = {
        method: 'POST',
        headers: {
          revision: '2023-09-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Step 2 store newsletter form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    location: {
                      ip: ip
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        })
      };

      try {
        var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VKHTQM', options);
        var successMessage = wrapper.querySelector('.success_message');
        var errorMessage = wrapper.querySelector('.error_message');

        if (response.status === 202) {
          if (successMessage) successMessage.style.display = '';
          if (errorMessage) errorMessage.style.display = 'none';
          if (emailInput) emailInput.value = '';
        } else {
          if (successMessage) successMessage.style.display = 'none';
          if (errorMessage) {
            errorMessage.style.display = '';
            errorMessage.textContent = 'Error. Please try again later.';
          }
        }

        if (response.status === 400) {
          if (successMessage) successMessage.style.display = 'none';
          if (errorMessage) {
            errorMessage.style.display = '';
            errorMessage.textContent = 'Please add a valid email.';
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (form) {
          form.classList.remove('active-loader');
        }
      }
    });
  });
});
